export const CALENDAR_YEAR = [
  {
    Kbn: 0,
    Diff: 0,
    Char: '',
    YearNm: '',
    Start: '',
    End: ''
  },
  {
    Kbn: 1,
    Diff: 1925,
    Char: 'S',
    YearNm: '昭和',
    Start: '1926-12-25',
    End: '1989-01-07'
  },
  {
    Kbn: 2,
    Char: 'H',
    Diff: 1988,
    YearNm: '平成',
    Start: '1989-01-08',
    End: '2019-04-30'
  },
  {
    Kbn: 3,
    Char: 'R',
    Diff: 2018,
    YearNm: '令和',
    Start: '2019-05-01',
    End: ''
  }
];



// WEBPACK FOOTER //
// ./src/app/models/CALENDAR_YEAR.ts